import {
    Component,
    OnInit,
    ChangeDetectionStrategy, Input, ViewChild, ElementRef, ChangeDetectorRef,
} from '@angular/core';
import {UsersService} from '../../services/users.service';
import {UserWaterViewModel} from '../../viewModels/userWater.viewModel';

@Component({
    selector: 'app-water-macro-bar-component',
    templateUrl: './water-macro-bar.component.html',
    styleUrls: ['./water-macro-bar.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class WaterMacroBarComponent {
    @ViewChild('wrapper') wrapper: ElementRef<HTMLElement>;

    _date: string = null;
    animationPercent = 0;
    increase_per_step = 100;

    userWater = new UserWaterViewModel();

    constructor(
        private readonly usersService: UsersService,
        private readonly changeDetectorRef: ChangeDetectorRef
    ) {
        this.userWater.water_target = 0;
        this.userWater.min_water_target = 0;
        this.userWater.consumed = 0;
    }

    @Input() set date(value: string) {
        this._date = value;

        // const percentB = document.getElementById('percentB');
        // const waterdrop = document.getElementById('waterdrop');
        // const waterdropWhite = document.getElementById('waterdrop-white');
        //
        // percentB.style.color = '#00ccff';
        // waterdrop.style.display = 'block';
        // waterdropWhite.style.display = 'none';
        // this.animationPercent = 0;

        this.usersService.getUserWater(this._date).subscribe(userWater => {
            this.userWater = userWater;

            let newPercent = this.userWater.consumed * 100 / this.userWater.water_target;

            if (newPercent >= 95) {
                newPercent = 90;
            }

            this.changeDetectorRef.detectChanges();

            // this.animateTo(newPercent);
        });
    }

    fixedNumber(number: number) {
        if (number === 0) {
            return 0;
        }

        return (number / 1000).toFixed(1);
    }

    increase() {
        const ml = this.userWater.consumed + this.increase_per_step;
        const target_ml = this.userWater.water_target;
        let new_percent = ml * 100 / target_ml;

        if (ml > target_ml) {
            return;
        }

        if (new_percent >= 95) {
            new_percent = 90;
        }

        this.updateMl(this.increase_per_step);

        this.userWater.consumed = ml;

        this.changeDetectorRef.detectChanges();

        // this.animateTo(new_percent);
    }

    animateTo(newPercent: number) {
        const percentB = document.getElementById('percentB');
        const water = document.getElementById('water');
        const waterdrop = document.getElementById('waterdrop');
        const waterdropWhite = document.getElementById('waterdrop-white');

        let percent = this.animationPercent;

        let interval;
        interval = setInterval(() => {
            percent += 5;
            // @ts-ignore
            water.style.transform = 'translate(0' + ',' + (100 - percent) + '%)';

            if (percent > 50) {
                percentB.style.color = '#fff';
                waterdrop.style.display = 'none';
                waterdropWhite.style.display = 'block';
            }

            if (percent >= newPercent) {
                this.animationPercent = newPercent;

                clearInterval(interval);
            }
        }, 120);
    }

    percentage(number1: number, dividedByNumber2: number): string {
        if (!dividedByNumber2 || dividedByNumber2 <= 0) {
            return '0%';
        }

        let percentage = Math.round((number1 / dividedByNumber2) * 100);

        if (percentage > 100) {
            percentage = 100;
        }

        return percentage + '%';
    }

    private updateMl(add_ml) {
        this.usersService.addUserWater(this._date, {add_ml: add_ml}).subscribe();
    }

}
